import React from "react";
import ReactDOM from "react-dom";
import { Carousel, Icon, Card } from "antd";
import SystemSet from "./systemSet";
import "../style/index.less";
import * as API from "../apis/index";
import WeaMessageCenterStore from "../stores/index";
import { escape2Html } from "../util";
import WeaLocaleProvider from "../../../ecology9/wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

export default class FixedPop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      visible: false,
      list: [],
      maxtime: 0,
      systemSetVisiable: false,
      msgid: ""
    };
    this.timer = null;
    this.count = 0;
    this.autoCloseTimer = null;
  }

  componentDidMount() {
    this.getPopMessage();
    this.timer = setInterval(() => {
      this.getPopMessage();
    }, this.props.intervalTime);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.intervalTime !== this.props.intervalTime) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getPopMessage();
      }, nextProps.intervalTime);
    }
    if (
      nextProps.visible !== undefined &&
      nextProps.visible !== this.state.visible
    ) {
      this.setState({ visible: nextProps.visible });
    }
  }

  getPopMessage = () => {
    if (window._message_center) {
      if (window._message_center.open) {
        return;
      }
    }
    this.count++;
    API.getPopList({ maxtime: this.state.maxtime }).then(res => {
      const result = {
        data: [
          {
            msgid: Math.random()
              .toString(36)
              .substr(2),
            name:
              Math.random()
                .toString(36)
                .substr(2) +
              ": " +
              this.count,
            link: "//www.baidu.com",
            title: "百度",
            context:
              "<img src='https://picsum.photos/960/300' />asdfsdf</br>sadfasdf"
          }
          // {
          //   name: Math.random()
          //     .toString(36)
          //     .substr(2),
          //   link: "//www.tianqi.com",
          //   title: "天气",
          //   context:
          //     "标题必填必填必填必填吧</br>标题必填必填必填必填吧</br>标题必填必填必填必填吧</br>阿士大夫撒打发斯蒂芬</br>asdfasdfsdf"
          // }
        ]
      };
      // res = result;
      if (res && res.data.length > 0) {
        const popContainer = $(`#pop-close-${this.props.id}`);
        popContainer.show();
        if ($(`#dialogMode-message-center-${this.props.id}`).length) {
          popContainer.find(".more-link").show();
        } else {
          popContainer.find(".more-link").hide();
        }

        // let msgidArr = [];
        // if (this.state.msgid !== "") {
        //   msgidArr = this.state.msgid.split(",");
        // }
        // msgidArr.push(res.msgid);
        clearInterval(this.autoCloseTimer);
        this.setState(
          {
            visible: true,
            // msgid: msgidArr.join(),
            maxtime: res.maxtime
          },
          function() {
            this.autoCloseTimer = setTimeout(() => {
              this.setState({
                visible: false
              });
            }, this.props.autoCloseTime);
          }
        );
        this.mixHistoryMessage(res);
      } else {
        // this.setState({ list: result });
      }
    });
  };

  mixHistoryMessage = res => {
    // console.log('res', res.data.map(item => item.name));
    const currentList = this.state.list;
    const resList = res.data;
    const newList = [...currentList.reverse(), ...resList];
    if (newList.length > 5) {
      const exceedLength = newList.length - 5;
      newList.splice(0, exceedLength);
    }
    newList.reverse();

    this.setState({
      list: newList
    });
  };

  clickTitle = (index, url) => {
    if (!url) {
      return false;
    }

    const currentList = this.state.list;
    window.open(url, "_blank");
    // setReadMsg
    API.setMsgRead({ msgid: currentList[index].messageid }).then(res => {
      // console.log(res);
    });
    currentList.splice(index, 1);
    // 没有数据关闭小窗
    if (currentList.length === 0) {
      this.setState({ visible: false });
    } else {
      this.setState({ list: currentList });
    }
  };

  render() {
    const title = this.state.list.filter((item, index) => {
      return index === this.state.index;
    });
    return (
      <div
        id={`pop-close-${this.props.id}`}
        style={this.state.visible ? { display: "block" } : { display: "none" }}
        className={"wea-messageCenter-fixedPop"}
      >
        <div className="wea-messageCenter-bodyContainer">
          <div className="wea-messageCenter-bodyTitle">
            {title[0] && title[0].name}
            <Icon
              onClick={() => {
                const numDom = $(
                  `#dialogMode-message-center-${
                    this.props.id
                  } .right-corner-num`
                );
                const listLength = this.state.list.length;
                const value = Number(numDom.text()) - listLength;
                if (value > 0) {
                  numDom.text(value);
                } else {
                  numDom.hide();
                }
                API.setMsgRead({
                  msgid: this.state.list.map(item => item.messageid).join()
                });
                this.setState({
                  visible: !this.state.visible,
                  list: [],
                  index: 0,
                  msgid: ""
                });
              }}
              className="wea-messageCenter-bodyTitleIcon"
              type="cross"
            />
          </div>
          <div className="wea-messageCenter-bodyCarousel">
            {this.state.list.length > 0 && (
              <Carousel
                dots={this.state.list.length > 1}
                afterChange={index => {
                  this.setState({ index });
                }}
              >
                {this.state.list.map((item, index) => {
                  return (
                    <div>
                      <div>
                        <Card
                          bordered={false}
                          className="wea-messageCenter-bodyCarouselItem"
                        >
                          <div className="title">
                            <a
                              target="_blank"
                              onClick={e => {
                                e.stopPropagation();
                                this.clickTitle(index, item.link);
                              }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  item.title && item.title.length < 70
                                    ? escape2Html(item.title)
                                    : escape2Html(item.title).substring(0, 70) +
                                      "..."
                              }}
                            />
                          </div>
                          <div className="content">
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  item.context &&
                                  item.context.replace(/<img[^>]+>/gi, "[图片]")
                              }}
                            />
                          </div>
                        </Card>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            )}
            <div
              style={{ width: "100px" }}
              className="corner-set"
              onClick={() => {
                this.setState({
                  systemSetVisiable: true
                });
              }}
            >
              <i className="icon-coms-Flow-setting" /> &ensp;
              {getLabel("21946", "提醒设置")}
            </div>
            <span className="more-link">
              <a
                onClick={() => {
                  $(`#dialogMode-message-center-${this.props.id}`).click();
                }}
                href="javascript: void(0);"
              >
                {getLabel("17499", "更多")}
              </a>
            </span>
            <SystemSet
              // systemSetStore={this.props.systemSetStore}
              systemSetStore={WeaMessageCenterStore}
              visible={this.state.systemSetVisiable}
              onCancel={() => {
                this.setState({
                  systemSetVisiable: false
                });
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/fixedPop.js